import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import '../../../../css/_decisionOverlay.scss';
import { useTranslation } from 'react-i18next';
import { FlexDiv } from '../../../design-system/containers';
import { rgba } from 'polished';
import { palette } from '../../../design-system/colors';
import { Heading2 } from '../../../design-system/headings';
import { TextDefault } from '../../../design-system/texts';

export const DecisionOverlay = observer(
    ({ decisionQuestion, onAnswer, isAtEnd }) => {
        const { t } = useTranslation();

        const madeDecision = (decision) => {
            onAnswer(decisionQuestion.id, decision);
        };

        useEffect(() => {}, [decisionQuestion]);

        return (
            <FlexDiv
                positionAbsolute
                zIndex={2}
                justifyCenter
                alignCenter
                fullWidth
                fullHeight
                column
                backgroundColor={rgba(0, 0, 0, 0.4)}
            >
                <FlexDiv
                    dropShadowBelow
                    borderRadius={3}
                    positionRelative
                    py={24}
                    px={48}
                >
                    <Heading2
                        classname="notranslate"
                        color={palette.graphite.white}
                        center
                    >
                        {isAtEnd
                            ? t('The end')
                            : t(decisionQuestion.questionText)}
                    </Heading2>
                </FlexDiv>
                {!isAtEnd && (
                    <FlexDiv desktopOnly gap={16}>
                        <FlexDiv
                            link
                            onClick={() =>
                                madeDecision(decisionQuestion.decision_1)
                            }
                            width={240}
                            justifyCenter
                            alignCenter
                            backgroundColor={palette.graphite.white}
                            borderRadius={4}
                            textAlignCenter
                        >
                            <TextDefault my={16} bold>
                                {t(decisionQuestion.decision_1.text)}
                            </TextDefault>
                        </FlexDiv>
                        <FlexDiv
                            link
                            onClick={() =>
                                madeDecision(decisionQuestion.decision_2)
                            }
                            width={240}
                            justifyCenter
                            alignCenter
                            backgroundColor={palette.graphite.white}
                            borderRadius={4}
                            textAlignCenter
                        >
                            <TextDefault my={16} bold>
                                {t(decisionQuestion.decision_2.text)}
                            </TextDefault>
                        </FlexDiv>
                    </FlexDiv>
                )}
            </FlexDiv>
        );
    }
);
